var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Twitter",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 37,
    height: 29,
    viewBox: "0 0 37 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_94",
    "data-name": "Rectangle 94",
    width: 37,
    height: 29,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_152",
    "data-name": "Group 152"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_151",
    "data-name": "Group 151",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_332",
    "data-name": "Path 332",
    d: "M37,3.429a15.727,15.727,0,0,1-4.365,1.162A7.421,7.421,0,0,0,35.976.533a15.5,15.5,0,0,1-4.823,1.776A7.682,7.682,0,0,0,25.619,0a7.46,7.46,0,0,0-7.592,7.32,7.153,7.153,0,0,0,.2,1.67A21.841,21.841,0,0,1,2.581,1.336,7.083,7.083,0,0,0,1.553,5.022a7.257,7.257,0,0,0,3.376,6.1A7.893,7.893,0,0,1,1.487,10.2v.086a7.4,7.4,0,0,0,6.087,7.181,7.745,7.745,0,0,1-1.995.263A8.282,8.282,0,0,1,4.149,17.6a7.584,7.584,0,0,0,7.089,5.086A15.612,15.612,0,0,1,1.81,25.819a15.426,15.426,0,0,1-1.81-.1A22.135,22.135,0,0,0,11.638,29a21.056,21.056,0,0,0,21.6-20.834c0-.317-.01-.633-.026-.945A14.723,14.723,0,0,0,37,3.429",
    fill: "#03a9f4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.cfdb24c62f8c33969031216114e91846.svg";
export { ForwardRef as ReactComponent };